export const VERSION_APP = '2.0.1';


// WEBPACK FOOTER //
// ./src/constants/version.ts